<ul class="action-menu">
    <li>
        <a (click)="remove()">{{ 'CHAT_GROUP_ATTENDEES_REMOVE' | translate }}</a>
    </li>
    <ng-container *ngIf="!participant.is_owner">
        <li>
            <a *ngIf="chatGroup.user_is_owner"
                (click)="addAdmin('owner')">{{ 'CHAT_GROUP_ATTENDEES_ADD_OWNER' | translate }}</a>
        </li>
        <li *ngIf="!participant.is_moderator">
            <a *ngIf="chatGroup.user_is_owner"
                (click)="addAdmin('moderator')">{{ 'CHAT_GROUP_ATTENDEES_ADD_MODERATOR' | translate }}</a>
        </li>
    </ng-container>
    <ng-container *ngIf="chatGroup.user_is_owner">
        <li *ngIf="participant.is_owner">
            <a (click)="removeAdmin()">{{ 'CHAT_GROUP_ATTENDEES_REMOVE_ADMIN' | translate }}</a>
        </li>
        <li *ngIf="participant.is_moderator">
            <a (click)="removeAdmin()">{{ 'CHAT_GROUP_ATTENDEES_REMOVE_MODERATOR' | translate }}</a>
        </li>
    </ng-container>
</ul>
